import { render, staticRenderFns } from "./BookPreviewer.vue?vue&type=template&id=6f7daf2a&scoped=true&"
import script from "./BookPreviewer.vue?vue&type=script&lang=js&"
export * from "./BookPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./BookPreviewer.vue?vue&type=style&index=0&id=6f7daf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7daf2a",
  null
  
)

export default component.exports